/* eslint-disable no-param-reassign */

// let's use this store so we can communicate desktop pricing card <--> sticky nav buy btn

const initialState = () => ({
  plan: null,
});

export { initialState as state };

export const mutations = {
  mutatePlan(state, data) {
    state.plan = data;
  },
};

export const actions = {
  updatePlan({ commit }, { selectedPlan }) {
    commit('mutatePlan', selectedPlan);
  },
};
